import React, { useState, useEffect, Suspense } from "react";
import Header from "./components/Header";
import Footer from "./components/Footer";
import { Outlet, useLocation } from "react-router-dom";

const App = () => {
  const location = useLocation();
  const [scrolled, setScrolled] = useState(false);
  const [lastScrollY, setLastScrollY] = useState(0);
  const [scrollDirection, setScrollDirection] = useState("up");

  const ARTICLE_ROUTES = [
    "/legal/privacy-policy", "/legal/terms-of-service",
    "/legal/copyright-policy", "/legal/cookie-policy",
    "/legal/safety-center", "/legal/child-safety-standards"
  ];
  const isArticlePage = ARTICLE_ROUTES.includes(location.pathname)
    || location.pathname.startsWith('/legal/');

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      if (currentScrollY > lastScrollY && currentScrollY >= 750) {
        setScrollDirection("down");
        setScrolled(true);
      } else if (currentScrollY < lastScrollY) {
        setScrollDirection("up");
        setScrolled(false);
      }

      setLastScrollY(currentScrollY);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [lastScrollY]);

  return (
    <div className="overflow-x-clip [&::-webkit-scrollbar]:hidden">
      {!isArticlePage && <Header scrolled={scrolled} />}
      <Suspense fallback={<div className="min-h-screen bg-black" />}>
        <Outlet />
      </Suspense>
      {/* <Footer /> */}
    </div>
  );
};

export default App;
